import MainNav from '@/pages/_components/main-nav/main-nav.vue';
import { withCurrentUser } from '@/shared/authentication';
export default withCurrentUser(MainNav);
